import { type FC } from 'react';

import { Heading, Text } from '../Typography';
import { amountStyles, lineStyles } from './PricingDetails.styles';
import { type PricingTotalProps } from './PricingDetails.types';

/**
 * Bold total row with a preformatted amount.
 *
 * Exported on its own so MembershipSummaryCard (and other summaries) can reuse
 * the same total treatment. Pair it with `Divider` when line items sit above it.
 */
const PricingTotal: FC<PricingTotalProps> = ({
  label,
  amount,
  prominent = false,
  className,
}) => {
  return (
    <div css={lineStyles} className={className}>
      <Text as="span" size="sm" fontWeight="bold" color="var(--text-primary)">
        {label}
      </Text>
      {prominent ? (
        <Heading
          as="span"
          color="var(--text-primary)"
          css={amountStyles}
          fontWeight="bold"
          size="xs"
        >
          {amount}
        </Heading>
      ) : (
        <Text
          as="span"
          color="var(--text-primary)"
          css={amountStyles}
          fontWeight="bold"
          size="sm"
        >
          {amount}
        </Text>
      )}
    </div>
  );
};

PricingTotal.displayName = 'PricingTotal';

export default PricingTotal;
